export class LeaseTemplateIdsRequiredError extends Error {
  constructor() {
    super();
    Object.setPrototypeOf(this, LeaseTemplateIdsRequiredError.prototype);
  }
}
